// 视频模式配置
<template>
    <div class="video-mode-box">
        <div class="view-box">
            <div class="screen-switch">
                <div class="screen-item" :class="{'is-active': currentScreen === item.id}" v-for="item in screenSwitchList" :key="item.id" @click="screenSwitch(item)">
                    <i class="icon" :class="{'portrait-icon': item.id === 1, 'landscape-icon': item.id === 2}"></i>{{item.name}}
                </div>
            </div>
            <div class="view-wrap">
                <div class="view">
                    <div class="portrait-view" v-show="currentScreen === 1">
                        <div id="portraitVideo" class="video" :style="`padding-top:${portrait.videoAreaTop}px; padding-bottom: ${portrait.videoAreaBottom}px; padding-left: ${portrait.videoAreaLeft}px; padding-right: ${portrait.videoAreaRight}px`">
                            <div v-for="(item, index) in portrait.videoList" :key="index" class="video-item" :style="`width: ${portrait.videoWidth}px;height: ${portrait.videoHeight}px`">
                                <div class="more-icon-box">
                                    <div class="more-icon"></div>
                                </div>
                                <div class="portrait-video-img"></div>
                                <div class="portrait-video-name-box">
                                    <div class="name">{{!index ? '主持人':'成员'}}</div>
                                    <div class="mic-icon"></div>
                                </div>
                            </div>
                        </div>
                        <div id="portraitIm" class="im-box" :class="{'tile': portrait.discussStyle === 2}">
                            <div class="discuss">
                                <span>讨论</span>
                                <div class="hide-icon"></div>
                            </div>
                            <div class="im-item">
                                <span class="label">主持人</span>
                                <span class="name">主持人：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                            <div class="im-item" v-for="i in 9" :key="i">
                                <span class="name">成员：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                        </div>
                    </div>
                    <div class="landscape-view" v-show="currentScreen === 2">
                        <div id="landscapeVideo" class="video" :style="`padding-top:${landscape.videoAreaTop}px; padding-bottom: ${landscape.videoAreaBottom}px; padding-left: ${landscape.videoAreaLeft}px; padding-right: ${landscape.videoAreaRight}px`">
                            <div v-for="(item, index) in landscape.videoList" :key="index" class="video-item" :style="`width: ${landscape.videoWidth}px;height: ${landscape.videoHeight}px`">
                                <div class="more-icon-box">
                                    <div class="more-icon"></div>
                                </div>
                                <div class="landscape-video-img"></div>
                                <div class="landscape-video-name-box">
                                    <div class="name">{{!index ? '主持人':'成员'}}</div>
                                    <div class="mic-icon"></div>
                                </div>
                            </div>
                        </div>
                        <div id="landscapeIm" class="im-box" :class="{'tile': landscape.discussStyle === 2}">
                            <div class="discuss">
                                <span>讨论</span>
                                <div class="hide-icon"></div>
                            </div>
                            <div class="im-item">
                                <span class="label">主持人</span>
                                <span class="name">主持人：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                            <div class="im-item" v-for="i in 6" :key="i">
                                <span class="name">成员：</span>
                                <span class="text">以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！以下为消息文字内容！</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="control-box">
            <div class="portrait-control-box" v-show="currentScreen === 1">
                <div class="video-area">
                    <div class="title">视频区域配置</div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaTop" :max="667" @input="videoAreaChange($event, 'top', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaBottom" :max="667" @input="videoAreaChange($event, 'bottom', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaLeft" :max="375" @input="videoAreaChange($event, 'left', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.videoAreaRight" :max="375" @input="videoAreaChange($event, 'right', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
                <div class="video-layout">
                    <div class="title">多人连麦视频布局配置</div>
                    <div class="video-layout-item">
                        <div class="item-name">多人布局</div>
                        <div class="item-content">
                            <div class="item-input">
                                行:
                                <el-input v-model="portrait.row" type="number" @input="numChange($event, 'row', 'portrait')"></el-input>
                            </div>
                            <div class="item-input">
                                列:
                                <el-input v-model="portrait.column" type="number" @input="numChange($event, 'column','portrait')"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">主持人固定位置</div>
                        <el-switch
                            v-model="portrait.hostFixed"
                            active-color="#2563EB"
                            @change="hostFixedChange($event, 'portrait')"
                        >
                        </el-switch>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">多人视频窗口展示</div>
                        <el-select v-model="portrait.videoCountChange" placeholder="请选择" @change="videoCountChange($event, 'portrait')">
                            <el-option
                                v-for="item in videoCountChangeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="discuss-area">
                    <div class="title">讨论展示配置</div>
                    <div class="discuss-area-item">
                        <div class="item-name">讨论样式</div>
                        <el-select v-model="portrait.discussStyle" placeholder="请选择" @change="discussStyleChange($event, 'portrait')">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <div class="discuss-area-item">
                        <div class="item-name">提示消息固定位置展示</div>
                        <el-switch
                            v-model="portrait.tipsFixed"
                            active-color="#2563EB"
                        >
                        </el-switch>
                    </div> -->
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaBottom" :max="667" @input="dicussAreaChange($event, 'bottom', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaLeft" :max="375" @input="dicussAreaChange($event, 'left', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                     <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaWidth" :max="375" @input="dicussAreaChange($event, 'width', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="portrait.discussAreaHeight" :max="667" @input="dicussAreaChange($event, 'height', 'portrait')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="landscape-control-box" v-show="currentScreen === 2">
                <div class="video-area">
                    <div class="title">视频区域配置</div>
                    <div class="slider-item">
                        <div class="item-name">顶部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaTop" :max="375" @input="videoAreaChange($event, 'top', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaBottom" :max="375" @input="videoAreaChange($event, 'bottom', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaLeft" :max="667" @input="videoAreaChange($event, 'left', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">右边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.videoAreaRight" :max="667" @input="videoAreaChange($event, 'right', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
                <div class="video-layout">
                    <div class="title">多人连麦视频布局配置</div>
                    <div class="video-layout-item">
                        <div class="item-name">多人布局</div>
                        <div class="item-content">
                            <div class="item-input">
                                行:
                                <el-input v-model="landscape.row" type="number" @input="numChange($event, 'row', 'landscape')"></el-input>
                            </div>
                            <div class="item-input">
                                列:
                                <el-input v-model="landscape.column" type="number" @input="numChange($event, 'column','landscape')"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">主持人固定位置</div>
                        <el-switch
                            v-model="landscape.hostFixed"
                            active-color="#2563EB"
                            @change="hostFixedChange($event, 'landscape')"
                        >
                        </el-switch>
                    </div>
                    <div class="video-layout-item">
                        <div class="item-name">多人视频窗口展示</div>
                        <el-select v-model="landscape.videoCountChange" placeholder="请选择" @change="videoCountChange($event, 'landscape')">
                            <el-option
                                v-for="item in videoCountChangeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="discuss-area">
                    <div class="title">讨论展示配置</div>
                    <div class="discuss-area-item">
                        <div class="item-name">讨论样式</div>
                        <el-select v-model="landscape.discussStyle" placeholder="请选择" @change="discussStyleChange($event, 'landscape')">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <div class="discuss-area-item">
                        <div class="item-name">提示消息固定位置展示</div>
                        <el-switch
                            v-model="landscape.tipsFixed"
                            active-color="#2563EB"
                        >
                        </el-switch>
                    </div> -->
                    <div class="slider-item">
                        <div class="item-name">底部边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaBottom" :max="375" @input="dicussAreaChange($event, 'bottom', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">左边距</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaLeft" :max="667" @input="dicussAreaChange($event, 'left', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域宽度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaWidth" :max="667" @input="dicussAreaChange($event, 'width', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                    <div class="slider-item">
                        <div class="item-name">区域高度</div>
                        <div class="item-content">
                            <el-slider v-model="landscape.discussAreaHeight" :max="375" @input="dicussAreaChange($event, 'height', 'landscape')" show-input></el-slider>
                            <span class="slider-text">px</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default: Object
    }
  },
  data () {
    return {
      screenSwitchList: [
        {
          id: 1,
          name: '竖屏'
        },
        {
          id: 2,
          name: '横屏'
        }
      ],
      currentScreen: 1,
      portrait: {
        row: 3,
        column: 3,
        videoWidth: 0,
        videoHeight: 0,
        videoAreaTop: 0,
        videoAreaBottom: 0,
        videoAreaLeft: 0,
        videoAreaRight: 0,
        viewWidth: 0,
        viewHeight: 0,
        videoList: [],
        hostFixed: true,
        discussStyle: 1,
        tipsFixed: true,
        discussAreaBottom: 0,
        discussAreaLeft: 0,
        discussAreaWidth: 0,
        discussAreaHeight: 0,
        videoCountChange: 2
      },
      landscape: {
        row: 3,
        column: 3,
        videoWidth: 0,
        videoHeight: 0,
        videoAreaTop: 0,
        videoAreaBottom: 0,
        videoAreaLeft: 0,
        videoAreaRight: 0,
        viewWidth: 0,
        viewHeight: 0,
        videoList: [],
        hostFixed: true,
        discussStyle: 1,
        tipsFixed: true,
        discussAreaBottom: 0,
        discussAreaLeft: 0,
        discussAreaWidth: 0,
        discussAreaHeight: 0,
        videoCountChange: 2
      },
      options: [
        {
          label: '弹幕式',
          value: 1
        },
        {
          label: '平铺式',
          value: 2
        }
      ],
      videoCountChangeOptions: [
        {
          label: '固定展示',
          value: 1
        },
        {
          label: '动态变化',
          value: 2
        }
      ]
    }
  },
  created () {
    // console.log('video-mode created config', this.config)
  },
  mounted () {
    this.portrait.viewWidth = 375// document.getElementsByClassName('portrait-view')[0].clientWidth
    this.portrait.viewHeight = 667// document.getElementsByClassName('portrait-view')[0].clientHeight
    this.landscape.viewWidth = this.portrait.viewHeight
    this.landscape.viewHeight = this.portrait.viewWidth
    this.getConfigData()
  },
  watch: {
    config (val) {
      // 获取父组件调用接口请求后的配置文件
      this.config = val
      this.currentScreen = 1
      this.getConfigData()
    }
  },
  methods: {
    screenSwitch (data) {
      this.currentScreen = data.id
    },
    getConfigData () {
      this.transConfigData('portrait')
      this.transConfigData('landscape')
    },
    transConfigData (screen) {
      // 根据最新配置文件更新view
      this[screen].row = this.config[screen].videoView.row
      this[screen].column = this.config[screen].videoView.column
      this[screen].videoAreaTop = this.config[screen].videoView.position.top
      this[screen].videoAreaBottom = this.config[screen].videoView.position.bottom
      this[screen].videoAreaLeft = this.config[screen].videoView.position.left
      this[screen].videoAreaRight = this.config[screen].videoView.position.right
      this[screen].hostFixed = this.config[screen].videoView.host_video_fixed === 2
      this[screen].discussStyle = this.config[screen].messageView.im_type
      // this[screen].tipsFixed = this.config[screen].messageView
      this[screen].discussAreaBottom = this.config[screen].messageView.position.bottom
      this[screen].discussAreaLeft = this.config[screen].messageView.position.left
      this[screen].discussAreaWidth = this.config[screen].messageView.position.width
      this[screen].discussAreaHeight = this.config[screen].messageView.position.height
      this[screen].videoCountChange = this.config[screen].videoView.video_count_change
      this.numChange(this[screen].column + '', 'column', screen)
    },
    // 视频区域样式更改
    videoAreaChange (val, type, screen) {
      this.updateVideoView(screen)
      // 更新config配置
      this.config[screen].videoView.position[type] = val
    },
    numChange (val, type, screen) {
      // 更新config配置
      this[screen].videoList = []
      if (Number(val) > 3) {
        this[screen][type] = 3
        this.config[screen].videoView[type] = 3
      } else {
        this[screen][type] = Number(val)
        this.config[screen].videoView[type] = Number(val)
      }
      for (let i = 0; i < this[screen].row * this[screen].column; i++) {
        this[screen].videoList.push({
          name: i
        })
      }
      // 固定展示时更新video_count
      if (this.config[screen].videoView.video_count_change === 1) {
        this.config[screen].videoView.video_count = this[screen].row * this[screen].column
      }
      // 视频窗口数量变化时需要调整视频窗口之间的间隙
      switch (type) {
        case 'row':
          switch (val) {
            case '1':
              this.$nextTick(() => {
                if (this[screen].column === 1) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.remove('marginB')
                } else if (this[screen].column === 2) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.remove('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.remove('marginB')
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.remove('marginB')
                  }
                }
              })
              break
            case '2':
              this.$nextTick(() => {
                if (this[screen].column === 2) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(3)`).classList.remove('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(4)`).classList.remove('marginB')
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                  for (let j = 3; j < 6; j++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${j + 1})`).classList.remove('marginB')
                  }
                } else if (this[screen].column === 1) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.remove('marginB')
                }
              })

              break
            case '3':
              this.$nextTick(() => {
                if (this[screen].column === 1) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.add('marginB')
                } else if (this[screen].column === 2) {
                  for (let i = 0; i < 4; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].column === 3) {
                  for (let i = 0; i < 6; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                }
              })

              break
          }
          break
        case 'column':
          switch (val) {
            case '1':
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.remove('marginB')
                } else if (this[screen].row === 3) {
                  document.querySelector(`#${screen}Video > div:nth-child(3)`).classList.remove('marginB')
                }
              })
              break
            case '2':
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  document.querySelector(`#${screen}Video > div:nth-child(1)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(2)`).classList.add('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(3)`).classList.remove('marginB')
                } else if (this[screen].row === 3) {
                  for (let i = 0; i < 4; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                  document.querySelector(`#${screen}Video > div:nth-child(5)`).classList.remove('marginB')
                  document.querySelector(`#${screen}Video > div:nth-child(6)`).classList.remove('marginB')
                }
              })
              break
            case '3':
              this.$nextTick(() => {
                if (this[screen].row === 2) {
                  for (let i = 0; i < 3; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                } else if (this[screen].row === 3) {
                  for (let i = 0; i < 6; i++) {
                    document.querySelector(`#${screen}Video > div:nth-child(${i + 1})`).classList.add('marginB')
                  }
                }
              })
              break
          }
          break
      }
      this.updateVideoView(screen)
    },
    updateVideoView (screen) {
      this[screen].videoWidth = this[screen].viewWidth - this[screen].videoAreaLeft - this[screen].videoAreaRight
      this[screen].videoHeight = this[screen].viewHeight - this[screen].videoAreaTop - this[screen].videoAreaBottom
      switch (Number(this[screen].row)) {
        case 1:
          this[screen].videoHeight = this[screen].videoHeight
          break
        case 2:
          this[screen].videoHeight = (this[screen].videoHeight - 2) / 2
          break
        case 3:
          this[screen].videoHeight = (this[screen].videoHeight - 4) / 3
          break
      }
      switch (Number(this[screen].column)) {
        case 1:
          this[screen].videoWidth = this[screen].videoWidth
          break
        case 2:
          this[screen].videoWidth = (this[screen].videoWidth - 2) / 2
          break
        case 3:
          this[screen].videoWidth = (this[screen].videoWidth - 4) / 3
          break
      }
      // 视频窗口高度小于200时需要调整样式
      this.$nextTick(() => {
        const videoImgList = Array.from(document.getElementsByClassName(`${screen}-video-img`))
        const videoNameBoxList = Array.from(document.getElementsByClassName(`${screen}-video-name-box`))
        if (this[screen].videoHeight < 100) {
          videoImgList.forEach((item) => {
            item.classList.add('small')
          })
          videoNameBoxList.forEach((item) => {
            item.classList.add('small')
          })
        } else {
          videoImgList.forEach((item) => {
            item.classList.remove('small')
          })
          videoNameBoxList.forEach((item) => {
            item.classList.remove('small')
          })
        }
      })
    },
    // 主持人固定位置更改
    hostFixedChange (val, screen) {
      this.config[screen].videoView.host_video_fixed = val ? 2 : 1
    },
    // 讨论样式更改
    discussStyleChange (val, screen) {
      this.config[screen].messageView.im_type = val
    },
    // 窗口展示
    videoCountChange (val, screen) {
      this[screen].videoCountChange = val
      this.config[screen].videoView.video_count_change = val
      if (this.config[screen].videoView.video_count_change === 1) {
        this.config[screen].videoView.video_count = this[screen].row * this[screen].column
      }
    },
    // 讨论区域位置更更改
    dicussAreaChange (val, type, screen) {
      const discussAreaDom = document.querySelector(`#${screen}Im`)
      switch (type) {
        case 'bottom':
          discussAreaDom.style.bottom = val + 'px'
          this.config[screen].messageView.position.bottom = val
          break
        case 'left':
          discussAreaDom.style.left = val + 'px'
          this.config[screen].messageView.position.left = val
          break
        case 'width':
          discussAreaDom.style.width = val + 'px'
          this.config[screen].messageView.position.width = val
          break
        case 'height':
          discussAreaDom.style.height = val + 'px'
          this.config[screen].messageView.position.height = val
          break
      }
    }
  }

}
</script>
<style lang="less" scoped>
.video-mode-box {
    display: flex;
    border-radius: 4px;
    width: 100%;
    min-height: 100%;
    .view-box {
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 160px;
        .screen-switch {
            flex-shrink: 0;
            margin: 24px 0;
            display: flex;
            width: 160px;
            height: 32px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
            border-radius: 4px;
            .screen-item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;
                height: 100%;
                cursor: pointer;
                font-size: 12px;
                color: #636c78;
                .icon{
                    display: flex;
                    align-items: center;
                    width: 20px;
                    height: 20px;
                    &.portrait-icon{
                        margin-left: -3px;
                        margin-right: 1px;
                        background-image: url('../assets/img/portrait-icon.png');
                        background-size: cover;
                    }
                    &.landscape-icon{
                        margin-left: -3px;
                        margin-right: 5px;
                        background-image: url('../assets/img/landscape-icon.png');
                        background-size: cover;
                    }
                }
                &.is-active{
                    background-color: rgba(37, 99, 235, 0.1);
                    box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
                    border-radius: 4px;
                    border: 1px solid #0062F4;
                    color: #2563EB;
                    .icon{
                        &.portrait-icon{
                            background-image: url('../assets/img/portrait-icon-active.png');
                        }
                        &.landscape-icon{
                            background-image: url('../assets/img/landscape-icon-active.png');
                        }
                    }
                }
            }
        }
        .view-wrap {
            display: flex;
            align-items: center;
            flex-grow: 1;
            .view {
                overflow: hidden;
                background-color: #171717;
                .portrait-view, .landscape-view{
                    position: relative;
                    width: 375px;
                    height: 667px;
                    .video {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        .video-item{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: space-between;
                            background-color: #1E1E1E;
                            overflow: hidden;
                            .more-icon-box {
                                align-self: flex-end;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin: 4px 4px 0 0;
                                width: 18px;
                                height: 14px;
                                background-color: rgba(0, 0, 0, 0.6);
                                border-radius: 3px;
                                .more-icon {
                                    width: 100%;
                                    height: 100%;
                                    background-image: url('../assets/img/video-more.png');
                                    background-size: cover;
                                }
                            }
                            .portrait-video-img, .landscape-video-img {
                                width: 41px;
                                height: 41px;
                                background-image: url('../assets/img/video-default-big.png');
                                background-size: cover;
                                &.small {
                                    width: 25px;
                                    height: 25px;
                                }
                            }
                            .portrait-video-name-box, .landscape-video-name-box {
                                align-self: flex-end;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin: 0 4px 4px 0;
                                padding: 0 8px;
                                // min-width: 24px;
                                height: 18px;
                                background-color: #000;
                                border-radius: 9px;
                                .name {
                                    margin-bottom: 1px;
                                    font-size: 20px;
                                    color: #fff;
                                    zoom: 0.5;
                                }
                                .mic-icon {
                                    margin-left: 2px;
                                    width: 10px;
                                    height: 10px;
                                    background-image: url('../assets/img/video-microphone-icon.png');
                                    background-size: cover;
                                }
                                &.small {
                                    margin: 0 3px 3px 0;
                                    padding: 0 5px;
                                    height: 16px;
                                    .name {
                                        font-size: 18px;
                                    }
                                }
                            }
                            &.marginB{
                                margin-bottom: 2px;
                            }
                        }
                    }
                    .im-box {
                        position: absolute;
                        left: 0;
                        bottom: 3px;
                        display: flex;
                        flex-direction: column;
                        overflow: hidden;
                        &.tile {
                            .discuss {
                                display: none;
                            }
                            .im-item {
                                margin-bottom: 0;
                                border-radius: 0;
                                background-color: #121212;
                            }
                        }
                        .discuss {
                            flex-shrink: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 0 6px 10px;
                            width: 105px;
                            height: 36px;
                            line-height: 36px;
                            font-size: 20px;
                            color: #fff;
                            background-color: rgba(0,0,0,0.42);
                            border-radius: 8px;
                            zoom: 0.5;
                            .hide-icon {
                                margin-left: 10px;
                                width: 16px;
                                height: 12px;
                                background-image: url('../assets/img/im-hide-icon.png');
                                background-size: cover;
                            }
                        }
                        .im-item {
                            margin-bottom: 6px;
                            padding: 8px 12px;
                            // max-width: 255px;
                            width: fit-content;
                            background-color: rgba(0,0,0,0.42);
                            border-radius: 0 4px 4px 0;
                            .label {
                                display: inline-block;
                                vertical-align: middle;
                                margin-right: 6px;
                                padding: 4px 4px;
                                border-radius: 4px;
                                font-size: 16px;
                                color: #fff;
                                background-color: #1A7BFF;
                                zoom: 0.5;
                                text-align: center;
                            }
                            .name {
                                font-size: 12px;
                                color: #1A7BFF;
                            }
                            .text{
                                font-size: 12px;
                                line-height: 16px;
                                color: #fff;
                            }
                        }
                    }
                }
                .landscape-view {
                    width: 667px;
                    height: 375px;
                }
            }
        }
    }
    .control-box {
        z-index: 6;
        position: fixed;
        right: 0;
        height: calc(100% - 64px);
        overflow: scroll;
        background-color: #FFFFFF;
        .portrait-control-box, .landscape-control-box {
            display: flex;
            flex-direction: column;
            width: 272px;
            font-size: 12px;
            .title {
                margin-bottom: 20px;
                font-size: 13px;
                font-weight: 600;
                color: #33383E
            }
            .slider-item {
                margin-bottom: 16px;
                &:last-child{
                    margin-bottom: 0;
                }
                .item-name {
                    margin-bottom: 2px;
                    color: #33383e;
                }
                .item-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .slider-text {
                        z-index: 1;
                        margin: 0 6px 4px 0;
                        font-size: 12px;
                        color: #9DA3AC;
                    }
                }
            }
            .video-area{
                padding: 24px 24px 8px;
            }
            .video-layout {
                padding: 24px 24px 8px;
                .video-layout-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    .item-name {
                        color: #33383e;
                    }
                    .item-content {
                        display: flex;
                        .item-input:nth-child(1) {
                            margin-right: 14px;
                        }
                        .el-input {
                            margin-left: 2px;
                            width: 32px;
                            height: 28px;
                        }
                    }
                }
            }
            .discuss-area {
                padding: 24px 24px 8px;
                .discuss-area-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                    .item-name {
                        color: #33383e;
                    }
                }
            }
        }
    }

}
</style>
<style scoped>
.el-slider {
    margin-right: 8px;
}
.el-input {
    font-size: 12px;
}
.el-input >>> .el-input__inner {
    padding: 0 10px;
    height: 28px;
    text-align: center;
    color: #33383e;
}
.el-slider >>> .el-input--small {
    font-size: 12px;
}
.el-slider >>> .el-slider__runway {
    margin: 13px 0 13px 5px;
    width: 154px;
    height: 2px;
}
.el-slider >>> .el-slider__button {
    /* margin-left: 9px; */
    width: 10px;
    height: 10px;
    border-color: #2563eb;
}
.el-slider >>> .el-slider__button-wrapper{
    width: 28px;
    height: 28px;
    top: -13px;
}
.el-slider >>> .el-slider__bar {
    height: 2px;
    background-color: #2563eb;
}
.el-slider >>> .el-slider__input{
    margin-top: -2px;
    width: 56px;
    height: 28px;
}
.el-slider >>> .el-input-number__decrease, .el-slider >>> .el-input-number__increase {
    display: none;
}
.el-slider >>> .el-input__inner {
    padding: 0 15px 0 0;
    margin-left: 64px;
    height: 28px;
    color: #33383e;
}
.el-select >>> .el-input__inner {
    padding-right: 0;
    padding-left: 10px;
    width: 82px;
    height: 28px;
    font-size: 12px;
    color: #33383e;
}
.el-select >>> .el-input__icon {
    display: flex;
    align-items: center;
    width: 12px;
    height: 28px;
    color: #919DAB;
}
.el-select >>> .el-input .el-select__caret.el-icon-arrow-up::before {
    background: url('../assets/img/arrow-icon.png');
    background-size: cover;
    transform: rotate(0deg);
}
.el-select >>> .el-input .el-select__caret.is-reverse.el-icon-arrow-up::before {
     transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/views/video-mode.vue